import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import useConditionalLogic from '../../../hooks/useConditionalLogic';
export default function ConditionalElement(props) {
  var actionType = props.actionType,
    logicType = props.logicType,
    elementsToMatch = props.elementsToMatch,
    rules = props.rules,
    children = props.children,
    resetElements = props.resetElements;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue;
  var conditionIsValid = useConditionalLogic(rules, {
    logicType: logicType,
    elementsToMatch: elementsToMatch
  });
  var isHidden = useMemo(function () {
    return actionType === 'show' && !conditionIsValid || actionType === 'hide' && conditionIsValid;
  }, [actionType, conditionIsValid]);
  var resetChild = function resetChild(child) {
    if (!child.props || !child.props.name) {
      return;
    }
    setValue(child.props.name, child.props.defaultValue || child.props.value);
  };
  var resetChildren = function resetChildren(children) {
    if (['string', 'undefined'].includes(typeof children)) {
      return;
    }
    if (Array.isArray(children)) {
      children.forEach(function (child) {
        if (child.type.name === 'ConditionalElement') {
          resetChildren(child.props.children);
        } else {
          resetChild(child);
        }
      });
    } else {
      resetChild(children);
    }
  };
  useEffect(function () {
    if (resetElements) {
      resetChildren(children);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [conditionIsValid]);
  if (isHidden) {
    return null;
  }
  return children;
}
ConditionalElement.propTypes = {
  actionType: PropTypes.string,
  logicType: PropTypes.string,
  elementsToMatch: PropTypes.number,
  rules: PropTypes.array.isRequired,
  resetElements: PropTypes.bool
};
ConditionalElement.defaultProps = {
  actionType: 'show',
  logicType: 'all',
  elementsToMatch: 1,
  resetElements: true
};